import * as React from 'react';
const PruritoIntimoFemminileIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M100 80.43v2.58M70.57 103.81c7.01 0 12.85 2.01 17.43 4.56M100.01 140.93v-9.53M118.13 92.08c2.03-1 3.99-2.2 5.18-2.99M76.8 89.09c3.79 2.53 12.44 7.37 23.2 7.37 2.37 0 4.63-.23 6.75-.6"
      className="prefix__cls-2"
    />
    <path
      d="M123.03 58.95c-6.51 11.5-1.42 27.57 3.69 38.41 1.06 2.26 2.12 4.53 2.86 6.92 3.67 11.93-.39 26.1-6.17 36.77M76.97 58.95c6.51 11.5 1.42 27.57-3.69 38.41-1.06 2.26-2.12 4.53-2.86 6.92-3.67 11.93.39 26.1 6.17 36.77"
      className="prefix__cls-2"
    />
    <path
      d="m109.7 102.95 3.97-5.34M114.03 108.61l6.19-4.08M117.55 114.81l6.45-1.53"
      className="prefix__cls-1"
    />
    <circle cx={100.06} cy={116.96} r={8.18} className="prefix__cls-1" />
    <circle cx={100.06} cy={116.96} r={1.17} className="prefix__cls-1" />
  </svg>
);
export default PruritoIntimoFemminileIcon;
